import Backbone from 'backbone';
import Cache from 'root/cache';
import Util from 'root/module/util';

var Survey = Backbone.Model.extend({
    defaults: {
        id                          : 0,
        account_id                  : 0,
        project_id                  : 0,
        is_active                   : false,
        first_active_time           : 0,
        survey_key                  : '',
        logo                        : '',
        format                      : 'paged',
        has_segment                 : false,
        user_segment                : '',
        device_type                 : 'desktop,tablet,phone',
        has_page_condition          : false,
        page_condition              : '',
        frequency                   : 'oncesubmit',
        trigger_type                : 'time',
        trigger_delay               : 0,
        trigger_action              : '',
        position                    : 'center',
        size                        : 'medium',
        start_time                  : 0,
        end_time                    : 0,
        align                       : 'left',
        highlight_colour            : '',
        complement_colour           : '',
        has_background_colour       : false,
        background_colour           : '',
        display_powered_by          : true,
        has_close_button            : false,
        has_required_indicator      : false,
        has_page_number             : false,
        system_text                 : '',
        has_captcha                 : false,
        total_response              : 0,
        total_open                  : 0
    },

    getScheduleText: function() {
        var text = '';

        switch(this.getStatus()) {
            case 'activated':
                if (this.isExpired() || this.get('end_time')) {
                    text = 'Deactive on ' + Util.moment(this.get('end_time'), 'DD MMM YYYY h:mm a', false, false);
                }
                break;
            case 'scheduled':
                if (this.get('start_time')) {
                    text = 'Activate on ' + Util.moment(this.get('start_time'), 'DD MMM YYYY h:mm a', false, false);

                    if (this.get('end_time')) {
                        text +=
                        '<br>' +
                        'Deactivate on ' + Util.moment(this.get('end_time'), 'DD MMM YYYY h:mm a', false, false);
                    }
                }
                break;
        }

        return text;
    },

    getStatus: function() {
        if (this.get('is_active')) {
            if ((!this.get('start_time') || Util.secondsDiff(this.get('start_time')) > 0)
                && (!this.get('end_time') || Util.secondsDiff(this.get('end_time')) < 0)
            ) {
                return 'activated';
            } else if (this.get('start_time') && Util.secondsDiff(this.get('start_time')) < 0) {
                return 'scheduled';
            }
        }

        return 'deactivated';
    },

    isExpired: function() {
        if (this.get('end_time') && Util.secondsDiff(this.get('end_time')) > 0) {
            return true;
        }

        return false;
    },

    getShareUrl: function() {
        return Cache.app.configs.survey_host.replace(/\/$/, '') + '/' + this.get('survey_key');
    }
});

export default Survey;
